import { combineReducers } from '@reduxjs/toolkit';
import { reducer as themeReducer } from '../slices/theme';
import { reducer as authReducer } from '../slices/auth';
import { reducer as chatReducer } from '../slices/chat';
import { reducer as chatUiReducer } from '../slices/chatUi';
import { reducer as snackbarReducer } from '../slices/snackbar';
import { reducer as dataReducer } from '../slices/data';
import { reducer as libraryReducer } from '../slices/library';
import { reducer as onboardingReducer } from '../slices/onboarding';
import { reducer as DocAnalyst } from '../slices/docAnalyst';
import { reducer as SmartMeet } from '../slices/smartMeet';
import { reducer as Projects } from '../slices/projects';
import { reducer as Assistant } from '../slices/assistant';
import { reducer as Model } from '../slices/model';
import { reducer as workflowDraftReducer } from '../slices/workflowDraft';
import { reducer as workflowBuilderUiReducer } from '../slices/workflowBuilderUi';
import { reducer as paygReducer } from '../slices/payg';

import { api } from 'src/services/api';
import { microsoftApi } from 'src/services/microsoftApi';
import { nmicrosoftApi } from 'src/newServices/microsoftApi';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

const authPersistConfig = {
  key: 'auth',
  storage,
  blacklist: ['isAuthorized']
};

const dataPersistConfig = {
  key: 'data',
  storage,
  whitelist: ['uploadTransactionId']
};

const rootReducer = combineReducers({
  theme: themeReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  chat: chatReducer,
  chatUi: chatUiReducer,
  snackbar: snackbarReducer,
  data: persistReducer(dataPersistConfig, dataReducer),
  library: libraryReducer,
  onboarding: onboardingReducer,
  docAnalyst: DocAnalyst,
  smartMeet: SmartMeet,
  projects: Projects,
  assistant: Assistant,
  model: Model,
  workflowDraft: workflowDraftReducer,
  workflowBuilderUi: workflowBuilderUiReducer,
  payg: paygReducer,
  [api.reducerPath]: api.reducer,
  [microsoftApi.reducerPath]: microsoftApi.reducer,
  [nmicrosoftApi.reducerPath]: nmicrosoftApi.reducer
});

export default rootReducer;
